export const LogoutIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.52483 17.8446H7.62414C11.0158 17.8446 12.6505 16.5078 12.9332 13.5133C12.9637 13.2001 12.7346 12.9175 12.4137 12.8869C12.1082 12.8564 11.8179 13.0932 11.7873 13.4064C11.5658 15.805 10.4352 16.6987 7.6165 16.6987H7.51719C4.40817 16.6987 3.30817 15.5987 3.30817 12.4897V7.50916C3.30817 4.40013 4.40817 3.30013 7.51719 3.30013H7.6165C10.4505 3.30013 11.5811 4.20916 11.7873 6.6536C11.8255 6.9668 12.0929 7.2036 12.4137 7.17305C12.7346 7.15013 12.9637 6.86749 12.9408 6.5543C12.6811 3.51402 11.0387 2.1543 7.62414 2.1543H7.52483C3.77414 2.1543 2.16997 3.75846 2.16997 7.50916V12.4897C2.16997 16.2404 3.77414 17.8446 7.52483 17.8446Z"
        fill="#222530"
      />
      <path
        d="M7.70815 10.5726H16.4012C16.7144 10.5726 16.9741 10.3129 16.9741 9.99967C16.9741 9.68648 16.7144 9.42676 16.4012 9.42676H7.70815C7.39495 9.42676 7.13523 9.68648 7.13523 9.99967C7.13523 10.3129 7.39495 10.5726 7.70815 10.5726Z"
        fill="#222530"
      />
      <path
        d="M14.6976 13.1321C14.8427 13.1321 14.9879 13.0786 15.1025 12.964L17.6615 10.405C17.883 10.1835 17.883 9.81682 17.6615 9.59529L15.1025 7.03626C14.8809 6.81474 14.5143 6.81474 14.2927 7.03626C14.0712 7.25779 14.0712 7.62446 14.2927 7.84599L16.4469 10.0002L14.2927 12.1543C14.0712 12.3758 14.0712 12.7425 14.2927 12.964C14.3997 13.0786 14.5525 13.1321 14.6976 13.1321Z"
        fill="#222530"
      />
    </svg>
  );
};
